module.exports = __webpack_public_path__ + "static/img/1738_phase_function_Paper_PointsHejduk_Prediction.5330b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1738_phase_function_Paper_PointsHejduk_Prediction.png
// module id = npAk
// module chunks = 0